module.exports = __webpack_public_path__ + "static/media/teatro cubano logo.3dcb210d.webp";